import { Box, Typography } from "@mui/material";
import { visuallyHidden } from "@mui/utils";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { FONT_SIZE } from "../../theme/tokens";
import { moneyOrHidden } from "./consts";

type Props = { totalCents: number; bonusCents: number; canViewWage: boolean };

/**
 * The one number the panel is about — the focal figure, top-right; everything below explains it. Unlabelled
 * on screen, where its place says what it is; the label stays for screen readers.
 */
export const HeaderTotal: FC<Props> = ({ totalCents, bonusCents, canViewWage }) => {
	const { t } = useTranslation();
	return (
		<Box sx={{ textAlign: "end", flex: "0 0 auto", ml: "auto" }}>
			<Box component="span" sx={visuallyHidden}>
				{t("wageBreakdown.header.total")}
			</Box>
			<Typography
				data-testid="wage-breakdown-header-total"
				sx={{ fontSize: FONT_SIZE.TITLE_XL, fontWeight: 700, lineHeight: 1.2, color: "text.primary", fontVariantNumeric: "tabular-nums" }}
			>
				{moneyOrHidden(totalCents, canViewWage)}
			</Typography>
			{bonusCents > 0 && (
				<Typography data-testid="wage-breakdown-header-bonus" sx={{ fontSize: FONT_SIZE.CAPTION, color: "text.secondary" }}>
					{t("wageBreakdown.header.bonusIncluded", { amount: moneyOrHidden(bonusCents, canViewWage) })}
				</Typography>
			)}
		</Box>
	);
};
